/** Parse the stored seat count (the single array element) to a number, or null when unset/blank/NaN. */
export function parseSeatCount(value: string | number | undefined): number | null {
  if (value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}
